<template lang="pug">
modal(:max-width="800")
	.card.text-left
		.card-header.bg-info.text-white
			span.fa.fa-folder-open.mr-2
			| Galería
			button.close(@click="cerrar") &times
		.card-body
			.row
				.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
					div.form-group(v-if="!galeria.UsuarioID")
						label Usuario
						input.form-control(disabled, :value="usuario.nombre + ' ' + usuario.apellidos")
					div.form-group(v-else)
						label Usuario
						input.form-control(disabled, :value="galeria.UsuarioNombre")
					.form-group
						label Nombre
						input.form-control(v-model="galeria.Nombre")
					.form-group
						label Descripcion
						textarea.form-control(v-model="galeria.Descripcion", rows="4")
					.form-group
						label Fecha
						datepicker(
							v-model="galeria.FechaGaleria"
							:bootstrap-styling="true"
							:monday-first="true"
							:language="$dateLang"
						)
				.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
					.form-group
						label Permitir por defecto
						br
						.btn-group
							button.btn(:class="(galeria.AccesoDefecto) ? 'btn-primary' : ''", @click="galeria.AccesoDefecto = !galeria.AccesoDefecto") Acceso
							button.btn(:class="(galeria.EscrituraDefecto) ? 'btn-primary' : ''", @click="galeria.EscrituraDefecto = !galeria.EscrituraDefecto") Escritura
					.form-group
						label Permisos
						input-query(
							:realtime="true"
							inputClass="form-control"
							placeholder="Buscar un usuario o grupo"
							@selected="seleccionaPermiso($event)"
							url="galerias/php/api/query-usuarios-grupos.php"
						)
					table.table.table-condensed.mt-2
						tr(v-for="(permiso, i) in galeria.permisos", :key="permiso.PermisoID")
							td
								span.fa(:class="(permiso.GrupoID) ? 'fa-users' : 'fa-user'")
							td
								span(v-if="permiso.GrupoID") {{permiso.GrupoNombre}}
								span(v-else) {{permiso.UsuarioNombre}}
							td
								.btn-group
									button.btn.btn-sm(:class="(permiso.Acceso) ? 'btn-success' : ''", @click="galeria.permisos[i].Acceso = !permiso.Acceso") Acceso
									button.btn.btn-sm(:class="(permiso.Escritura) ? 'btn-success' : ''", @click="galeria.permisos[i].Escritura = !permiso.Escritura") Escritura
									button.btn.btn-sm.btn-danger(@click="quitaPermiso(permiso.PermisoID)")
										span.fa.fa-trash
		.card-body.bg-light
			.row
				.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
					.form-group
						label Etiquetas
						input-query(
							inputClass="form-control"
							:realtime="true"
							url="galerias/php/api/query-etiquetas.php"
							@selected="addEtiqueta($event)"
							placeholder="Buscar o crea una nueva etiqueta"
						)
				.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
					div.contieneEtiquetas
						button.btn.btn-danger.m-2(
							@click="quitarEtiqueta(eti)"
							v-for="eti in galeria.etiquetas"
						)
							| {{eti}}
							span.fa.fa-trash.ml-2
		.card-footer
			.row
				.col.text-left
					button.btn.btn-primary(@click="guardar")
						span.fa.fa-save.mr-2
						| Guardar
				.col.text-right(v-if="galeria.GaleriaID")
					button.btn.btn-danger(@click="eliminar")
						span.fa.fa-trash.mr-2
						| Eliminar galería
</template>

<script>
import { mapGetters } from 'vuex'
import API from '../../api.js'
export default {
	props: ['idGaleria'],
	data () {
		return {
			galeria: {
				GaleriaID: null,
				Nombre: null,
				Descripcion: null,
				UsuarioID: null,
				UsuarioNombre: null,
				FechaCreacion: null,
				FechaGaleria: null,
				Eliminada: null,
				AccesoDefecto: true,
				EscrituraDefecto: true,
				permisos: [],
				rrss: false,
				prensa: false,
				tv: false,
				web: false,
				etiquetas: []
			}
		}
	},
	created () {
		if (this.idGaleria && this.idGaleria !== 'nueva') {
			API.getGaleria(this.idGaleria)
				.then(res => {
					res.data.galeria.FechaGaleria = new Date(res.data.galeria.FechaGaleriaUnix * 1000)
					this.galeria = res.data.galeria
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		})
	},
	methods: {
		addEtiqueta (ev) {
			if (this.galeria.etiquetas.indexOf(ev.texto) >= 0) {
				return false
			}
			this.galeria.etiquetas.push(ev.texto)
		},
		quitarEtiqueta (eti) {
			this.galeria.etiquetas.splice(this.galeria.etiquetas.indexOf(eti), 1)
		},
		seleccionaPermiso (ev) {
			if (ev.datos.ID_grupo) {
				// Buscamos que el grupo no esté ya
				for (let i = 0; i < this.galeria.permisos.length; i++) {
					if (this.galeria.permisos[i].GrupoID === ev.datos.ID_grupo) {
						return
					}
				}
				let j = this.galeria.permisos.length
				this.galeria.permisos.push({
					PermisoID: 'permiso' + j,
					GaleriaID: this.galeria.GaleriaID,
					UsuarioID: null,
					GrupoID: ev.datos.ID_grupo,
					UsuarioNombre: null,
					GrupoNombre: ev.datos.nombre,
					Acceso: false,
					Escritura: false
				})
			} else if (ev.datos.ID) {
				for (let i = 0; i < this.galeria.permisos.length; i++) {
					if (this.galeria.permisos[i].UsuarioID === ev.datos.ID) {
						return
					}
				}
				let j = this.galeria.permisos.length
				// Es un usuario
				this.galeria.permisos.push({
					PermisoID: 'permiso' + j,
					GaleriaID: this.galeria.GaleriaID,
					UsuarioID: ev.datos.ID,
					UsuarioNombre: ev.datos.nombre + ' ' + ev.datos.apellidos,
					GrupoNombre: null,
					GrupoID: null,
					Acceso: false,
					Escritura: false
				})
			}
		},
		quitaPermiso (idPermiso) {
			this.galeria.permisos = this.galeria.permisos.filter(per => {
				if (per.PermisoID === idPermiso) {
					return false
				}
				return true
			})
		},
		guardar () {
			if (!this.galeria.Nombre) {
				this.$error('Error', 'Debes definir el nombre de la galería')
				return
			}
			if (!this.galeria.FechaGaleria) {
				this.$error('Error', 'Debes definir la fecha de la galería')
				return
			}
			const nueva = (this.galeria.GaleriaID === null)
			API.setGaleria(this.galeria)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Guardada',
						mensaje: 'Se ha guardado la galería'
					})
					res.data.galeria.FechaGaleria = new Date(res.data.galeria.FechaGaleriaUnix * 1000)
					this.galeria = res.data.galeria
					if (nueva) {
						this.$router.push('/main/galerias/' + this.galeria.GaleriaID)
					}
					this.cerrar()
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: 'Error guardando la galería'
					})
				})
		},
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar galería',
				mensaje: `¿Quieres eliminar esta galería?
				Esta acción no se podrá deshacer`,
				callback: acepta => {
					if (acepta) {
						API.delGaleria(this.galeria.GaleriaID)
							.then(res => {
								this.$store.commit('toast/success', {
									titulo: 'Galería eliminada'
								})
								this.$router.push('/main/galerias')
								this.cerrar()
							})
							.catch(e => {
								this.$store.commit('toast/danger', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/listado-galerias/modal-galeria.vue